<template>
	<div class="modal-data">
		<div class="title flex-space-around--center">Enter the url with parameters to create sample data</div>
		<div class="sub-title flex-space-around--center">
			Note that some characters (such as "/" or whitespace) are not allowed in URLs. Use the URL encoder to run your test <br />
			If you need to encode a URL in your module use the action "URL encoder" under "format"
		</div>
		<v-text-field
			style="z-index: 2"
			v-model="localUrl"
			placeholder="Link with parameters"
			height="52"
			class="url-field"
			color="primary"
			outlined
			hint="Change xxxx with the relavent sample data"
			single-line
			@focus="$event.target.select()"
		>
		</v-text-field>
		<div class="flex-space-around--center">
			<v-btn pressed dark class="btn btn-lg btn-primary ml-2" @click="test" :disable="!validUrl">Test</v-btn>
		</div>
		<div v-if="!validUrl">Please provide a valid URL</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import { triggerUrl } from '@/store/modules/selectedWorkflow/getters';
export default {
	name: 'TestTriggerModal',
	components: {},
	props: [],
	mounted() {
		this.localUrl = this[triggerUrl.fullPath];
	},
	watch: {
		localUrl: {
			handler() {
				this.validUrl = true;
			},
		},
		initialUrl: {
			handler(value) {
				if (this.localUrl !== value) {
					this.localUrl = value;
				}
			},
		},
	},
	computed: {
		...mapGetters([triggerUrl.fullPath]),
		initialUrl() {
			return this[triggerUrl.fullPath];
		},
	},
	methods: {
		test() {
			try {
				const testValidUrl = new URL(this.localUrl);
				const parameters = {};
				testValidUrl.searchParams.forEach((value, key) => (parameters[key] = value));
				const testData = { params_map: { url_parameters: parameters } };
				this.$emit('test-node', testData);
			} catch (err) {
				console.log(err);
				this.validUrl = false;
			}
		},
	},
	data: () => ({
		localUrl: '',
		validUrl: true,
	}),
};
</script>

<style scoped>
.modal-data {
	background: white;
	padding: 10px;
}
.title {
	padding: 10px;
}
.sub-title {
	padding: 10px;

	font-size: 12px;
}
.url-field {
	padding-top: 10px;
}
</style>
